module.exports = __webpack_public_path__ + "media/images/report_areas/gany-52c0e6a1ddb6d4bcca3342934a033b7b.bmp";